/**
 * Shared UI copy for the marketing video components (poster, modal player,
 * transcript, quiet card previews) — namespace `videoKit`. The video CONTENT
 * (spoken text, transcript) is not here: it lives with the deliverable in
 * `src/lib/marketing-videos.ts`, because it is Dutch by nature and tied to the
 * mastered file, not to the visitor's UI language.
 */

export const videoKitEn = {
  playAriaLabel: "Play video: {title} ({duration})",
  closeLabel: "Close video",
  captionsLabel: "Nederlands",
  captionsNote: "Dutch captions available — turn them on in the player if you want them.",
  languageNote: "This video is spoken in Dutch, with Dutch captions.",
  previewLabel: "Preview — this demo is being finalized.",
  transcriptToggle: "Read the video transcript (in Dutch)",
  pendingTitle: "The demo video for this page is being finished",
  pendingBody:
    "We only publish final, checked videos here — no rough cuts. Until then, the steps below describe exactly what you would see.",
  errorTitle: "The video cannot be loaded right now",
  errorBody:
    "Please try again later. The transcript below the player describes the same flow step by step.",
  previewStop: "Stop the moving preview",
  previewStart: "Play the preview again",
};

export const videoKitNl = {
  playAriaLabel: "Video afspelen: {title} ({duration})",
  closeLabel: "Video sluiten",
  captionsLabel: "Nederlands",
  captionsNote: "Nederlandse ondertiteling beschikbaar — zet deze desgewenst aan in de speler.",
  languageNote: "Deze video is Nederlands gesproken, met Nederlandse ondertiteling.",
  previewLabel: "Preview — deze demo wordt afgerond.",
  transcriptToggle: "Lees het videotranscript",
  pendingTitle: "De demovideo voor deze pagina wordt afgerond",
  pendingBody:
    "We plaatsen hier alleen definitieve, gecontroleerde video's — geen ruwe versies. Tot die tijd beschrijven de stappen hieronder precies wat je zou zien.",
  errorTitle: "De video kan op dit moment niet worden geladen",
  errorBody:
    "Probeer het later opnieuw. Het transcript onder de speler beschrijft dezelfde flow stap voor stap.",
  previewStop: "Stop de bewegende preview",
  previewStart: "Speel de preview opnieuw af",
};
